import i18next from 'i18next';
import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import type { Slicers } from 'types/services';
import { getBaseUrl } from 'utils/baseUrl';
import { isMobileApp } from 'utils/common';

export const createBaseQuery = ({ extendedUrl }: { extendedUrl: string }) =>
  fetchBaseQuery({
    baseUrl: getBaseUrl(`/api/${extendedUrl}`),
    paramsSerializer: (params) => {
      const searchParams = new URLSearchParams();

      for (const [key, value] of Object.entries(params)) {
        if (value === undefined || value === null) {
          continue;
        }
        if (Array.isArray(value)) {
          value.forEach((v) => searchParams.append(key, v));
        } else {
          searchParams.append(key, value);
        }
      }

      return searchParams.toString();
    },
    prepareHeaders: async (headers, { getState }) => {
      const { auth } = getState() as Slicers;
      const mobileApp = isMobileApp();
      const { refreshToken, tokenProvider, jwtToken, apiKey } = auth;

      if (jwtToken) {
        if (!headers.has('Authorization')) {
          headers.set('Authorization', jwtToken ?? '');
        }
      }

      if (refreshToken) {
        headers.set('X-Refresh-Token', refreshToken ?? '');
      }

      if (tokenProvider) {
        headers.set('X-Authorization-Provider', tokenProvider ?? '');
      }

      headers.set('X-Mobile-Platform', '');
      headers.set('X-Device-Type', mobileApp ? 'Mobile' : 'Browser');
      headers.set('Accept-Language', i18next.language);

      headers.set('X-Api-Key', apiKey ?? '');

      return headers;
    },
  });
